import { createStore } from 'vuex'
import {getMusicLyric} from '@/request/api/item.js'
import {getLoginInfo} from '@/request/api/home.js'

export default createStore({
  state: {
    playList:[{
      al:{
        id: 2681139,
        name: "意外",
        pic: 109951163830384660,
        picUrl: "https://p2.music.126.net/9A0ob2sGFC8bt3f6EH5vcQ==/109951163830384653.jpg",
        pic_str: "109951163830384653"
      },
      ar:[{
        name:'薛之谦'
      }],
      name:"意外",
      id: 27808044,
    }], 
    playListIndex:0,//默认下标为0
    isbtnShow:true,//暂停按钮的显示
    isPopups:false,//歌曲详情页的显示
    lyricList:{},//歌词
    currentTime:0,//歌曲播放当前时间
    duration:0,//歌曲总时长
    isLogin:false,//是否登录
    isFooterMusic:true,//底部播放组件显示
    token:'',//token值
    userid:'',//用户id
   //用户信息
    userInfo: {}
  },
  getters: {
  },
  mutations: {
    updateIsbtnShow(state,value){
      state.isbtnShow=value
    },
    pushPlayList(state,value){
      // console.log(state.playList);
      state.playList.push(value)
    },
    updatePlayList(state,value){
      // console.log(state.playList);
      state.playList=value
    },
    updateplayListIndex(state,value){
      // console.log(state.playListIndex);
      state.playListIndex=value
    },
    updateIsPopups(state,value){
      state.isPopups=value
    },
    updatelyricList(state,value){
      state.lyricList=value
    },
    updatecurrenTime(state,value){
      // console.log(state.currentTime);
      state.currentTime=value
    },
    updateduration(state,value){
      // console.log(state.duration);
      state.duration=value
    },
    updateisLogin(state){
      state.isLogin=true
    },
    updatetoken(state,value){
      state.token=value
      localStorage.setItem('token',state.token)
    },
    updateUserId(state,value){
      
      state.userid=value
      localStorage.setItem('userId',state.userid)
      // state.userid=JSON.parse(localStorage.getItem('userId'))
      // console.log( state.userid);
    },
    updateUserInfo(state,value){
      state.userInfo=value 
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    }, 
  },
  actions: {
    getLyric: async function(context,value){
      let {data:res}=await getMusicLyric(value)
      context.commit("updatelyricList",res.lrc)
    },
    getLogin: async function(context,value){
      let res=await getLoginInfo(value)
     console.log(res);
     return res
    }
  },
  modules: {
  }
})
